export enum LenderDealStatusEnum {
  MARKETING = 'Marketing',
  TENDER = 'Tender',
  LEGALS = 'Legals',
  CLOSED = 'Closed',
  DECLINED = 'Declined',
  INVOLVED = 'Involved',
  NDA = 'NDA',
}
